import supabase from "../config/supabaseConfig";

// Chama a Edge Function criar-professor (A5). O functions.invoke já manda o
// JWT da sessão logada no Authorization; o gate de papel (admin/líder cria
// professor, só admin cria admin/líder) é validado DENTRO da function.
export async function criarUsuarioComLogin({
  nome,
  email,
  senha,
  papel, // 'professor' | 'admin' | 'lider'
  idade,
  especialidade,
  experiencia,
  formacao,
  // admin/líder que TAMBÉM dá aula (Alex, Marco): a function cria a linha
  // em professores junto — sem ela a Sala não resolve a identidade.
  tambemProfessor,
}) {
  const { data, error } = await supabase.functions.invoke("criar-professor", {
    body: {
      nome,
      email,
      senha,
      papel,
      idade,
      especialidade,
      experiencia,
      formacao,
      tambem_professor: tambemProfessor === true,
    },
  });

  if (error) {
    // FunctionsHttpError guarda o Response em error.context — extrai a
    // mensagem pt-BR que a function devolve em { error }.
    let msg = error.message;
    try {
      const body = await error.context?.json();
      if (body?.error) msg = body.error;
    } catch {
      // corpo não-JSON (ex.: gateway) — fica com a mensagem genérica
    }
    throw new Error(msg);
  }

  return data; // { user_id, email, papel }
}

const criarUsuarioService = { criarUsuarioComLogin };
export default criarUsuarioService;
